import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
  margin-bottom: ${props => props.theme.spacing.sp32};
`

export const LineItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: ${props => props.theme.spacing.sp16};
  border-bottom: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};

  > *:not(:last-child) {
    border-bottom: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
    padding-bottom: ${props => props.theme.spacing.sp16};
    margin-bottom: ${props => props.theme.spacing.sp16};
  }
`

export const CounterContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp4};
  align-items: center;
`

export const NotifyContainer = styled.div`
  padding-top: ${props => props.theme.spacing.sp16};
  border-top: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
`

export const ActionsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
`
